import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import download from 'downloadjs';
import update from 'react-addons-update';
import { Commons, LnbList } from 'components';

import * as bookMark from 'actions/bookMark';
import * as commons from 'actions/commons';

import menuList from 'config/menuList';
import { safeHistoryPush } from 'helpers/pathValidator';
import storage from 'helpers/storage';
import toastr from 'helpers/toastr';
import cm from 'helpers/commons';

import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import {
  AccountManagement,
  AffiliateStoreList,
  Bill,
  BookingStats,
  BookingStatus,
  CompanyInfo,
  CompanyNotice,
  CompanySikdaePolicy,
  DashBoard,
  DeductionSikdaeCard,
  DeductionSikdaeCNT,
  DeductionSikdaeKimAndChang,
  DeductionSikdaeMedical,
  DivisionManagementByExcel,
  DetailedSikdae,
  DetailedSikdaeV2,
  DetailedSikdaeSamsungSds,
  DivisionStats,
  DormantStaffManagement,
  ExcelDownload,
  HolidayManagement,
  MealApproveList,
  MealApproveManagement,
  MyPointList,
  OurhomeSubtractStat,
  PaymentReasonList,
  PushMessage,
  RemainingSikdae,
  Search,
  SettlementDetail,
  SettlementList,
  SikdaeGiveDeduct,
  SikdaeGiveDeductByExcel,
  SikdaeGivenList,
  SikdaeGroupStats,
  SikdaeUseStats,
  StaffInfo,
  StaffManagement,
  StaffManagementByExcel,
  StaffManagementMeal,
  StaffSignUp,
  StoreStats,
  UserInfo,
  UserSikdaeGivenList,
  UserSikdaeGrandDeductHistory,
  UserSikdaeUsageHistory,
  EmployeeCardPayment,
  EmployeeCardPaymentByExcel
} from 'containers';
import SurveyModal from '../components/Header/SurveyModal';
import ExcelRequestCompleteModal from './ExcelRequestCompleteModal';
// import RecommendEvent from './RecommendEvent';
import NotFound from './NotFound';
import { ChannelTalk } from '../layouts/MainLayout';

// ExcelRequestCompleteModal

class Main extends Component {
  constructor(props) {
    super(props);
    this.time = null;
    this.state = {
      title: '',
      excel: null,
      isLoading: false,
      downloadExcelFile: '',
      pageExcelHandler: null,
      menu: menuList,
      blockRender: true,
      error: null,
      isVisbles: false
    };
  }

  async componentWillMount() {
    const { rootProps, history, commonsFn } = this.props;

    const pass = storage.get('password');
    if (pass && pass !== 'NONE') {
      history.push('/');
    }
    try {
      await rootProps.fn.meCall();

      // channel talk boot by user profile
      const company = storage.get('company') || {};
      const { user = {} } = company;

      if (user && user.id && user.grade !== 'SUPER') {
        commonsFn.staffDetailSelSel(user.id);
      }

      // channelTalkService.boot({
      //   pluginKey: api.config.channel_tolk_plugin_key, // please fill with your plugin key
      //   userId: user.id,
      //   profile: {
      //     name: user.name,
      //     company: user.company.name,
      //     userId: company.userID
      //   }
      // });

      this.setState({ blockRender: false }); // Main 랜더링을 한다.
      rootProps.fn.divisionSel();
      this.menuTitle();
    } catch (e) {
      const result = e.response;
      let state = null;
      if (result && result.data) {
        /**
         * me API error
         */
        const { status } = result.data;
        switch (status) {
          case -401:
            toastr('top-right', 'warning', '아이디 혹은 비밀번호가 잘못 입력된 것 같아요. 다시 입력해주세요.');
            break;
          default:
            toastr('top-right', 'error', result.data.message);
            break;
        }
      } else {
        /**
         * me API 알수 없는 error 또는
         * link 클릭 하여 진입 했을 때 로그인 정보가 없으므로 error,
         */

        /**
         * bill 청구서 link 클릭으로 진입했을 시
         * invoiced: 청구서 날짜,
         * account: 청구서 idx
         */
        const invoiced = cm.getQuerystring('invoiced');
        const account = Number(cm.getQuerystring('account'));
        console.log('link error', invoiced, account);
        if (invoiced && account) {
          state = {
            type: 'bill',
            invoiced,
            account
          };
        }
        console.log('##### e: ', e);
      }

      const { logout } = rootProps;
      this.setState({ blockRender: true }); // Main을 랜더링 하지 않는다.
      setTimeout(() => {
        if (state) {
          const result = e.response;
          const { status } = result.data;
          if (status == -900) {
            // 서비스를 이용중이지 않음.
            history.push({
              // 로그인 페이지로 이동
              pathname: '/service/landing',
              search: '',
              state
            });
          } else {
            logout(() => {
              storage.clearLogout();
              history.push({
                // 로그인 페이지로 이동
                pathname: '/',
                search: '',
                state
              });
            });
          }
        } else {
          logout();
        }
      }, 1500);
    }
  }

  componentDidUpdate(prevProps) {
    // 라우터가 내려주는 location을 기준으로 비교한다. window.location과 비교하면
    // props가 갱신되지 않는 상황에서 조건이 계속 참이 되어
    // setState → 리렌더 → componentDidUpdate 무한 루프에 빠질 수 있다.
    const {
      location: { pathname }
    } = this.props;
    if (prevProps.location.pathname !== pathname) {
      const { menu } = this.state;
      let menuInfo = {};
      menu.depth1.forEach((menuItem) => {
        const depth = menuItem.depth2 || [];
        const array = depth.filter((item) => item.url === pathname)[0];
        if (array) {
          menuInfo = array;
        }
      });
      this.updateMenuState(menuInfo);
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });
    // this.props.history.push('/main');
  }

  componentWillUnmount() {
    if (this.time) {
      clearTimeout(this.time);
      this.time = null;
    }
  }

  menuTitle = () => {
    const { menu } = this.state;
    const url = this.props.history.location.pathname;
    let title = '';
    let excel = null;

    // 메뉴 타이틀 저장
    menu.depth1.map((menu) => {
      const depth2 = menu.depth2.filter((depth2) => depth2.url == url);
      if (depth2.length > 0) {
        title = depth2[0].name;
        excel = depth2[0].excel;
      }
    });
    this.setState({
      title,
      excel
    });
    this.bookMarkList();
  };

  updateMenuState = (menuInfo) => {
    if (menuInfo.url) {
      this.setState({
        title: menuInfo.name,
        excel: menuInfo.excel,
        error: null,
        errorInfo: null
      });
    }
  };

  lnbMenuClick = (menu) => {
    if (!menu.url) {
      return;
    }
    // ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
    safeHistoryPush(this.props.history, menu.url);
    this.updateMenuState(menu);
  };

  /*
    즐겨찾기 추가
    code : menu conde
  */
  bookMarkAdd = async (code, isAdd) => {
    if (!isAdd) {
      const { bookMark } = this.props;
      try {
        const params = {
          code
        };
        await bookMark.add(params);
        await bookMark.list();
      } catch (e) {
        const { response } = e;

        if (response && response.data) {
          toastr('top-right', 'warning', response.data.message);
        }
      }
    }
  };

  // 즐겨찾기 조회
  bookMarkList = async () => {
    const { bookMark } = this.props;

    try {
      await bookMark.list();
      const { listResult } = this.props;
    } catch (e) {
      console.log('###### bookMarkList : ', e);
    } finally {
    }
  };

  // 즐겨찾기 삭제
  bookMarkDel = async (code) => {
    const { bookMark } = this.props;
    try {
      await bookMark.del(code);
      this.bookMarkList();
    } catch (e) {}
  };

  downloadExcel = async (excelType) => {
    const com = storage.get('company');
    const { userCount } = storage.get('userCount');
    const isBackgroundExcelDown = userCount >= 1000;

    const { excel, isLoading, title, downloadExcelFile } = this.state;
    const { excelResult } = this.props;
    const params = {
      com,
      excel,
      excelResult
    };
    const { commonsFn } = this.props;
    let header = null;

    const url = this.props.history.location.pathname;
    const isAsyncExcelDown =
      url === '/main/userSikdaeGivenList' ||
      url === '/main/sikdaeGivenList' ||
      url === '/main/DetailedSikdae' ||
      url === '/main/DetailedSikdaePro' ||
      url === '/main/DetailedSikdaeSamsungSds';

    if (isLoading) {
      toastr('top-right', 'warning', `${downloadExcelFile} 엑셀파일을 생성 중입니다.`);
      return;
    }

    try {
      await this.setState({
        isLoading: true,
        downloadExcelFile: title
      });

      if (isAsyncExcelDown && userCount && isBackgroundExcelDown) {
        setTimeout(() => {
          this.setState({ isLoading: false, isVisbles: true });
        }, 5000);
      }

      if (params.excelResult) {
        const { excel } = params.excelResult;
        excel.data = excelType;
      } else {
        params.excelResult = {
          excel: { data: excelType }
        };
      }

      await commonsFn.excelDownload(params);

      if (!isAsyncExcelDown || !isBackgroundExcelDown) {
        const { excelDownloadReault } = this.props;

        if (excelDownloadReault) {
          header = excelDownloadReault.headers['content-disposition'];
          header = header.split('=');
        }

        download(excelDownloadReault.data, decodeURIComponent(header[1]));
        toastr('top-right', 'success', `${this.state.downloadExcelFile} 엑셀파일 생성 완료 되었습니다.`);
      }
    } catch (e) {
      const result = e.response;
      if (result && result.data) {
        const { status } = result;
        toastr('top-right', 'error', ` 엑셀파일 생성에 실패 하였습니다.(${String(status)})`);
      }
      console.log('###### ExcelDownLoad : ', e);
    } finally {
      if (!isAsyncExcelDown || !isBackgroundExcelDown) {
        await this.setState({ isLoading: false });
      }
    }
  };

  lnbDepth2OnOff = (idx) => {
    const { menu } = this.state;
    const { isOpen } = menu.depth1[idx];
    this.setState({
      menu: update(this.state.menu, {
        depth1: {
          [idx]: {
            isOpen: { $set: !isOpen }
          }
        }
      })
    });
  };

  excelMenuShow = () => {
    const { menu } = this.state;
    const idx = menu.depth1.length - 1;
    const { isShow } = menu.depth1[idx];
    if (!isShow) {
      this.setState({
        menu: update(this.state.menu, {
          depth1: {
            [idx]: {
              isShow: { $set: true }
            }
          }
        })
      });
    }
  };

  onExcelDownList = () => {
    const { history } = this.props;
    this.setState({ isVisbles: false, excel: false });
    history.push('/main/excelDownloadList');
  };

  registerPageExcelHandler = (handler) => {
    this.setState({
      pageExcelHandler: handler || null
    });
  };

  render() {
    const url = this.props.history.location.pathname;
    const { location, staffDetail } = this.props;
    const {
      bookMarkMenu,
      title,
      excel,
      menu,
      isLoading,
      blockRender,
      error,
      errorInfo,
      isVisbles,
      pageExcelHandler
    } = this.state;
    const { appFunction, company, navi, rootProps } = this.props;
    const pathname = window.location.href;
    const { logout } = rootProps;
    if (blockRender) {
      return <Commons.LoadingBar />;
    }

    const isUserInfo = staffDetail && staffDetail.data && staffDetail.data.user;
    const myInfo = isUserInfo ? { ...staffDetail.data.user, cellphone: staffDetail.data.user.phone } : undefined;

    const lnbMenuFn = {
      lnbMenuClick: this.lnbMenuClick,
      bookMarkAdd: this.bookMarkAdd,
      bookMarkList: this.bookMarkList,
      bookMarkDel: this.bookMarkDel,
      lnbDepth2OnOff: this.lnbDepth2OnOff,
      bookMarkMenu
    };

    // 로그아웃·세션 정리(clearLogout) 직후 리렌더에서는 company가 비어 있다
    const companyInfo = storage.get('company') || {};
    const companyUser = companyInfo.user;
    const companyList = companyInfo.list;
    const companyId = companyInfo.id;
    const isShowDetailListExcel = url === '/main/userSikdaeGivenList' || url === '/main/sikdaeGivenList';

    let companyName = '';

    if (companyList) {
      if (companyList.length !== 0) {
        companyList.some((data) => {
          if (data.id === companyId) {
            companyName = data.name;
            return true;
          }
        });
      } else {
        companyName = companyUser.company.name;
      }
    }

    return (
      <div className="corp-wrapper">
        <SurveyModal />
        <ChannelTalk key={myInfo} location={location} myInfo={myInfo} />
        <div className="main-box">
          {companyUser ? (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {/* <header className="main-header">
                <Header.List logout={logout} key={pathname} />
              </header> */}
              <div style={{ display: 'flex', height: '100%' }}>
                <nav className="main-nav" style={{ flex: '0 0 239px' }}>
                  <LnbList lnbMenuFn={lnbMenuFn} menu={menu} />
                </nav>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    width: '100%',
                    overflow: 'hidden'
                  }}
                >
                  <section className="main-section" style={{ flex: 1 }}>
                    <div className="inner">
                      <div className="top-title">
                        <Grid>
                          <Grid.Column>
                            <h2 className="main-title">{url === '/main/dashBoard' ? companyName : this.state.title}</h2>
                          </Grid.Column>
                        </Grid>
                      </div>
                      <div className="top-btn button">
                        <Button.Group>
                          {isShowDetailListExcel ? (
                            <Button
                              loading={isLoading}
                              style={{ width: 224, marginRight: 16 }}
                              inverted
                              color="green"
                              onClick={(e) => this.downloadExcel('DETAIL')}
                            >
                              전체 상세내역 엑셀 다운로드
                            </Button>
                          ) : null}
                          {excel &&
                          url !== '/main/dashBoard' &&
                          url !== '/main/excelDownloadList' &&
                          url !== '/main/DetailedSikdaePro' &&
                          url !== '/main/DetailedSikdaeSamsungSds' ? (
                            excel.isShow ? (
                              <Button
                                key={excel}
                                loading={isLoading}
                                style={{ width: 184 }}
                                inverted
                                color="green"
                                onClick={(e) => this.downloadExcel('LIST')}
                              >
                                엑셀 다운로드
                              </Button>
                            ) : null
                          ) : null}
                          {excel && (url === '/main/DetailedSikdaePro' || url === '/main/DetailedSikdaeSamsungSds') && (
                            <Button
                              key={excel}
                              loading={isLoading}
                              style={{ width: 184 }}
                              inverted
                              color="green"
                              onClick={pageExcelHandler}
                            >
                              엑셀 다운로드
                            </Button>
                          )}
                        </Button.Group>
                      </div>
                    </div>
                  </section>
                  <div style={{ height: 'calc(100% - 70px)', padding: '20px', overflowY: 'auto' }}>
                    <Switch>
                      {error && errorInfo ? <div>{error.toString()}</div> : null}
                      <Route path="/main/dashBoard" component={DashBoard} />
                      <Route path="/main/companySikdaePolicy" component={CompanySikdaePolicy} />
                      {/* <Route path="/main/event" component={RecommendEvent} /> */}
                      <Route path="/main/companyInfo" component={CompanyInfo} />
                      <Route path="/main/Search" component={Search} />
                      <Route
                        path="/main/staffManagement"
                        render={(props) => <StaffManagement {...props} divisionSel={rootProps.fn.divisionSel} />}
                        // component={ StaffManagement }
                      />
                      <Route
                        path="/main/dormantStaffManagement"
                        render={(props) => <DormantStaffManagement {...props} divisionSel={rootProps.fn.divisionSel} />}
                        // component={ StaffManagement }
                      />
                      <Route
                        path="/main/staffManagementMeal"
                        render={(props) => <StaffManagementMeal {...props} divisionSel={rootProps.fn.divisionSel} />}
                        // component={ StaffManagement }
                      />
                      <Route path="/main/staffManagementByExcel" component={StaffManagementByExcel} />
                      <Route path="/main/divisionManagementByExcel" component={DivisionManagementByExcel} />
                      <Route path="/main/signup" component={StaffSignUp} />
                      <Route
                        path="/main/sikdaeGiveDeduct"
                        render={(props) => <SikdaeGiveDeduct {...props} excelMenuShow={this.excelMenuShow} />}
                        // component={ SikdaeGiveDeduct }
                      />
                      <Route path="/main/sikdaeGiveDeductByExcel" component={SikdaeGiveDeductByExcel} />
                      <Route path="/main/settlementList" component={SettlementList} />
                      <Route path="/main/settlementDetail/:companyId/:taxUnitSeq" component={SettlementDetail} />
                      <Route path="/main/sikdaeGivenList" component={SikdaeGivenList} />
                      <Route path="/main/mealApproveList" component={MealApproveList} />
                      <Route path="/main/mealApproveManagement" component={MealApproveManagement} />
                      <Route path="/main/MyPointList" component={MyPointList} />
                      <Route path="/main/userSikdaeGivenList" component={UserSikdaeGivenList} />
                      <Route path="/main/staffInfo/:type/:id" component={StaffInfo} />
                      <Route path="/main/storeStats" component={StoreStats} />
                      <Route path="/main/divisionStats" component={DivisionStats} />
                      <Route path="/main/SikdaeUseStats" component={SikdaeUseStats} />
                      <Route path="/main/salary-deduction" component={DeductionSikdaeCard} />
                      <Route path="/main/salary-deduction-cnt" component={DeductionSikdaeCNT} />
                      <Route path="/main/salary-deduction-medical" component={DeductionSikdaeMedical} />
                      <Route path="/main/salary-deduction-kimandchang" component={DeductionSikdaeKimAndChang} />
                      <Route path="/main/ourhomeSubtractStat" component={OurhomeSubtractStat} />
                      <Route path="/main/sikdaeGroupStats" component={SikdaeGroupStats} />
                      <Route
                        exact
                        path="/main/DetailedSikdae"
                        render={(props) => <DetailedSikdae {...props} divisionSel={rootProps.fn.divisionSelAll} />}
                      />
                      <Route
                        exact
                        path="/main/DetailedSikdaePro"
                        render={(props) => (
                          <DetailedSikdaeV2
                            {...props}
                            divisionSel={rootProps.fn.divisionSelAll}
                            registerExcelHandler={this.registerPageExcelHandler}
                          />
                        )}
                      />
                      <Route
                        exact
                        path="/main/DetailedSikdaeSamsungSds"
                        render={(props) => (
                          <DetailedSikdaeSamsungSds
                            {...props}
                            divisionSel={rootProps.fn.divisionSelAll}
                            registerExcelHandler={this.registerPageExcelHandler}
                          />
                        )}
                      />
                      <Route path="/main/PaymentReason" component={PaymentReasonList} />
                      <Route path="/main/noticeList" component={CompanyNotice} />
                      <Route path="/main/pushMessage" component={PushMessage} />
                      <Route path="/main/excelDownloadList" component={ExcelDownload} />
                      <Route path="/main/storeList" component={AffiliateStoreList} />
                      <Route path="/main/accountManagement" component={AccountManagement} />
                      <Route path="/main/remainingSikdae" component={RemainingSikdae} />
                      <Route path="/main/bill" component={Bill} />
                      {/* 사원증 결제정보 관리는 폐지됐다. 주소로 들어와도 대시보드로 보낸다 */}
                      <Redirect from="/main/barcodeMemberList" to="/main/dashBoard" />
                      <Route path="/main/bookingStatus" component={BookingStatus} />
                      <Route path="/main/bookingStats" component={BookingStats} />
                      <Route path="/main/MyInfo" component={UserInfo} />
                      <Route path="/main/holidayManagement" component={HolidayManagement} />
                      <Route path="/main/employeeCardPaymentByExcel" component={EmployeeCardPaymentByExcel} />
                      <Route path="/main/employeeCardPayment" component={EmployeeCardPayment} />
                      <Route path="/main/userSikdaeUsageHistory" component={UserSikdaeUsageHistory} />
                      <Route path="/main/userSikdaeGrandDeductHistory" component={UserSikdaeGrandDeductHistory} />

                      <Route path="/main/*" component={NotFound} />
                    </Switch>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Commons.LoadingBar />
          )}
        </div>

        <ExcelRequestCompleteModal
          open={isVisbles}
          close={() => this.setState({ isVisbles: false })}
          onExcelDownList={this.onExcelDownList}
        />
      </div>
    );
  }
}

Main.contextTypes = {
  router: PropTypes.object.isRequired
};

Main = connect(
  (state) => ({
    addResult: state.bookMark.addResult,
    listResult: state.bookMark.listResult,
    delResult: state.bookMark.delResult,
    excelResult: state.commons.excel,
    excelDownloadReault: state.commons.excelDownload,
    navi: state.commons.navi,
    company: state.auth.company,
    staff: state.commons.staff,
    staffDetail: state.commons.staffDetail
  }),
  (dispatch) => ({
    bookMark: bindActionCreators(
      {
        add: bookMark.Add,
        list: bookMark.List,
        del: bookMark.Del
      },
      dispatch
    ),

    commonsFn: bindActionCreators(
      {
        changeExcel: commons.ChangeExcel,
        excelDownload: commons.ExcelDownload,
        staffSel: commons.StaffSel,
        staffDetailSelSel: commons.StaffDetailSel
      },
      dispatch
    )
  })
)(Main);

export default withRouter(Main);
